// apiUtils.js
// Shared utilities for API calls

// Base API configuration
export const API_BASE_URL = '/api';

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => `${API_BASE_URL}${endpoint}`;

// Default headers for all requests
export const defaultHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
};
